var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"pa-2"},[_c('v-data-table',{staticStyle:{"width":"100%"},attrs:{"dense":"","height":_vm.getHeight,"footer-props":{
                         pagination: {
                         itemsPerPage: 100
                         }
                      },"headers":_vm.headers,"items":_vm.ROWS.data},scopedSlots:_vm._u([{key:"item",fn:function({item}){return [_c('tr',[_c('td',[_vm._v(_vm._s(item.user_id))]),_c('td',[_vm._v(_vm._s(new Date(item.log_date).toLocaleString()))])])]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }